import React, { useEffect, useRef } from "react";

const FocusTrap = ({ open, trigger, children }) => {
    const focusRef = useRef(null);
    
    useEffect(() => {
        if (open) {
            const focusElement = focusRef.current;
            const focusableElements = focusElement.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            const handleTabPress = (event) => {
                if (event.key === "Tab") {
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } else if (
                        !event.shiftKey
                        && document.activeElement === lastElement
                    ) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            };
            const handleEscapeKeyPress = (event) => {
                if (event.key === "Escape") {
                    open.setOpen(null);
                    trigger.current.focus();
                }
            };
            focusElement.addEventListener("keydown", handleTabPress);
            focusElement.addEventListener("keydown", handleEscapeKeyPress);
            
            return () => {
                focusElement.removeEventListener("keydown", handleTabPress);
                focusElement.removeEventListener("keydown", handleEscapeKeyPress);
            };
        }
        return null;
    }, [open]);
    
    return (
        <div ref={focusRef}>
            {children}
        </div>
    );
};

export default FocusTrap;
